export default __webpack_public_path__ + "static/media/hamburger.2c026e50.svg";